// Wishlist service using localStorage
const WISHLIST_KEY = 'iwantcheats_wishlist';

export const wishlistService = {
  getWishlist: () => {
    const wishlist = localStorage.getItem(WISHLIST_KEY);
    return wishlist ? JSON.parse(wishlist) : [];
  },

  addToWishlist: (product) => {
    const wishlist = wishlistService.getWishlist();
    if (!wishlist.find(item => item.id === product.id)) {
      wishlist.push(product);
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    }
    return wishlist;
  },

  removeFromWishlist: (productId) => {
    const wishlist = wishlistService.getWishlist();
    const filtered = wishlist.filter(item => item.id !== productId);
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(filtered));
    return filtered;
  },

  isInWishlist: (productId) => {
    const wishlist = wishlistService.getWishlist();
    return wishlist.some(item => item.id === productId);
  },

  clearWishlist: () => {
    localStorage.removeItem(WISHLIST_KEY);
  }
};
